export default __webpack_public_path__ + "static/media/gl-1.94ac7a06.png";